const texto = {

    Conservador () {
        return `<div class="texto" style="text-align:justify;">
                    De acordo com as respostas ao questionário, identificamos que o seu 
                    perfil de investidor é CONSERVADOR!
                </div><br>
                <div class="texto" style="text-align:justify;">
                    Isso significa que você prioriza a segurança do investimento, mesmo que isso
                    signifique ganhar menos dinheiro. Você opta por investimentos sem nenhum risco de
                    perda, alocando a maior parcela de seus recursos em investimentos de renda fixa.
                    Seu objetivo é sempre conservar o seu poder de compra, ou seja, se manter acima da
                    inflação. O quesito prazo também é considerado, uma vez que os objetivos financeiros
                    são de curto ou médio prazo, existe o receio da perda de recursos com opções mais
                    arriscadas.
                </div>`
    },

    ConservadorInfo () {
        return `CONSERVADOR: Isso significa que você prioriza a segurança do investimento, mesmo que isso
                signifique ganhar menos dinheiro. Você opta por investimentos sem nenhum risco de
                perda, alocando a maior parcela de seus recursos em investimentos de renda fixa.
                Seu objetivo é sempre conservar o seu poder de compra, ou seja, se manter acima da
                inflação. O quesito prazo também é considerado, uma vez que os objetivos financeiros
                são de curto ou médio prazo, existe o receio da perda de recursos com opções mais
                arriscadas.`
    },

    Moderado () {
        return `<div class="texto" style="text-align:justify;">
                    De acordo com as respostas ao questionário, identificamos que o seu 
                    perfil de investidor é MODERADO!
                </div><br>
                <div class="texto" style="text-align:justify;">
                    Isso significa que você não abre mão da segurança no momento de investir, mas é
                    mais tolerante ao risco, com o objetivo de ter uma rentabilidade acima das taxas
                    básicas de mercado.
                    O objetivo do investidor com perfil moderado é diversificar seus recursos, diluindo
                    assim o risco, e maximizando os ganhos. Os fundos Multimercado são excelentes
                    alternativas para esse perfil, pois dentro de um único produto você está inserido dentro
                    de vários mercados (renda fixa, renda variável. Câmbio, e outros).
                    Outro ponto importante é que você procura investir no médio e longo prazo, o que
                    garante maior retorno. Tempo é o grande segredo no momento de investir!
                </div>`
    },

    ModeradoInfo () {
        return `MODERADO: Isso significa que você não abre mão da segurança no momento de investir, mas é
                mais tolerante ao risco, com o objetivo de ter uma rentabilidade acima das taxas
                básicas de mercado.
                O objetivo do investidor com perfil moderado é diversificar seus recursos, diluindo
                assim o risco, e maximizando os ganhos. Os fundos Multimercado são excelentes
                alternativas para esse perfil, pois dentro de um único produto você está inserido dentro
                de vários mercados (renda fixa, renda variável. Câmbio, e outros).
                Outro ponto importante é que você procura investir no médio e longo prazo, o que
                garante maior retorno. Tempo é o grande segredo no momento de investir!`
    },

    Arrojado () {
        return `<div class="texto" style="text-align:justify;">
                    De acordo com as respostas ao questionário, identificamos que o seu 
                    perfil de investidor é ARROJADO! 
                </div><br>
                <div class="texto" style="text-align:justify;">
                    Isso significa que você está disposto a assumir todos os riscos para ter o melhor
                    retorno possível. Você entende que as perdas a curto prazo são momentâneas e
                    necessárias para aproveitar lucros mais altos no longo prazo.
                    Seu objetivo é aumentar seu patrimônio de forma considerável. Você conhece os
                    produtos de investimentos, e suporta as oscilações do mercado. Prefere aplicar seus
                    recursos em renda variável, e principalmente em ações de empresas que oferecem
                    maior probabilidade de retorno para aumentar seu patrimônio.
                    Mesmo tendo um perfil arrojado, é importante que o investidor agressivo tenha uma
                    reserva de emergência para situação do cotidiano que demandem dinheiro a curto
                    prazo.
                </div>`
    },

    ArrojadoInfo () {
        return `ARROJADO: Isso significa que você está disposto a assumir todos os riscos para ter o melhor
                retorno possível. Você entende que as perdas a curto prazo são momentâneas e
                necessárias para aproveitar lucros mais altos no longo prazo.
                Seu objetivo é aumentar seu patrimônio de forma considerável. Você conhece os
                produtos de investimentos, e suporta as oscilações do mercado. Prefere aplicar seus
                recursos em renda variável, e principalmente em ações de empresas que oferecem
                maior probabilidade de retorno para aumentar seu patrimônio.
                Mesmo tendo um perfil arrojado, é importante que o investidor agressivo tenha uma
                reserva de emergência para situação do cotidiano que demandem dinheiro a curto
                prazo.`
    },

    Investidor (p) {
       
        let valor = parseFloat(p);

        if (valor <= 23) {
            return this.Conservador();
        }

        else if (valor <= 35) {
            return this.Moderado();
        }

        return this.Arrojado();
    },

    OutrosInvestidores (p) {
       
        let valor = parseFloat(p);

        if (valor <= 23) {
            // Conservador
            return {
                texto1: this.ModeradoInfo(), 
                texto2: this.ArrojadoInfo()
            }
        }

        else if (valor <= 35) {
            // Moderado
            return {
                texto1: this.ConservadorInfo(),
                texto2: this.ArrojadoInfo()
            }
        }

        // Arrojado
        return {
            texto1: this.ConservadorInfo(), 
            texto2: this.ModeradoInfo()
        }
    }

}

export default texto;


// WEBPACK FOOTER //
// ./src/helpers/texto-investidor.js